module.exports = __webpack_public_path__ + "img/rf2.a856e941.png";